import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlMonth } from '../ControlMonth'

import { control } from './control'

/**
 * @param {string} name
 * @param {number | null} value
 * @param {Object} defaultProps
 */
export function month(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlMonth, defaultProps)
}
